import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { ref: "pieChartRef" }
const _hoisted_4 = { ref: "lineChartRef" }
const _hoisted_5 = { class: "grid-3" }
const _hoisted_6 = { ref: "barChartRef" }
const _hoisted_7 = { ref: "donutChartRef" }
const _hoisted_8 = { ref: "radarChartRef" }
const _hoisted_9 = { ref: "polarAreaChartRef" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Dashboard", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("canvas", _hoisted_3, null, 512)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("canvas", _hoisted_4, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("canvas", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("canvas", _hoisted_7, null, 512)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("canvas", _hoisted_8, null, 512)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("canvas", _hoisted_9, null, 512)
        ])
      ])
    ])
  ]))
}